import { render, staticRenderFns } from "./DamageDetail.vue?vue&type=template&id=5bfe9e20&scoped=true"
import script from "./DamageDetail.vue?vue&type=script&lang=js"
export * from "./DamageDetail.vue?vue&type=script&lang=js"
import style0 from "./DamageDetail.vue?vue&type=style&index=0&id=5bfe9e20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe9e20",
  null
  
)

export default component.exports